export const sanitiseAiredaleStringParam = (param: string): string => {
  return param.replace(/\W|_/g, '*');
};
